import { render, staticRenderFns } from "./RevenueRadarCard.vue?vue&type=template&id=0607b0e2"
import script from "./RevenueRadarCard.vue?vue&type=script&lang=js"
export * from "./RevenueRadarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports